import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatorsComponent } from './operators/operators.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { OperatorCardComponent } from './operator-card/operator-card.component';
import { CalendarComponent } from 'src/app/components/calendar/calendar.component';
import { AcceptScheduleComponent } from './accept-schedule/accept-schedule.component';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { GmtMessageComponent } from './gmt-message/gmt-message.component';
import { StarRatingModule } from 'angular-star-rating';

const declarations = [
  OperatorsComponent,
  OperatorCardComponent,
  CalendarComponent,
  AcceptScheduleComponent,
  GmtMessageComponent,
];

@NgModule({
  declarations,
  imports: [
    IonicModule,
    ReactiveFormsModule,
    CommonModule,
    PipeModule,
    TranslateModule,
    GeneralesComponentsModule,
    StarRatingModule,
  ],
  exports: declarations,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CalendarComponentsModule {}
